import axios from "axios-observable";
import { APIURL } from "../constant/common";
import _ from "lodash";
import { createHashHistory } from 'history' // or createBrowserHistory
const history = createHashHistory()

export const Http = axios.create({
  baseURL: APIURL,
  timeout: 50000,
  maxContentLength: 200000000
});

// Add a request interceptor
Http.interceptors.request.use(
  function (config) {
    let token = localStorage.getItem("studioToken");
    if (token) {
      config.headers["Authorization"] = "bearer " + token;
    }
    // Do something before request is sent
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
Http.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    if (_.size(response.data) > 0 || response.status === 200 || response.status === 204) {
      return response.data;
    } else return Promise.reject({ message: "No Result" });
  },
  function (error) {
    if (error.response && error.response.status === 401) {
      const originalRequest = error.config;
      let refreshToken = localStorage.getItem("studioRefreshToken");
      if (
        refreshToken &&
        error.response.status === 401 &&
        !originalRequest._retry
      ) {
        originalRequest._retry = true;
        return new Promise((resolve) => {
          try{
            Http
            .post(`${APIURL}auth/refreshToken`, { refreshToken: refreshToken }).subscribe(
              (res: any) => {
              if (res) {
                localStorage.setItem("studioToken", res.token);
                localStorage.setItem("studioRefreshToken", res.refreshToken);
                resolve(Http.request(originalRequest).toPromise());
              } 
            },
            err => {
              localStorage.clear();
              history.push('/signin')
              return;
            })
          } catch (e) {
            localStorage.clear();
            history.push('/signin')
            return;
          }
        })
      } else {
        localStorage.clear();
        history.push('/signin')
        return;
      }
    }
    return Promise.reject(error.response ? error.response.data : error);
  }
);
